import { useState } from 'react'

import { Button } from '@atoms'

import { scopedTranslation } from '@utils/I18n'

import { RosterExportModal } from './RosterExportModal'

const t = scopedTranslation('roster_board')

type ExportRosterButtonProps = {
  event: { id: string; name: string }
}

export function ExportRosterButton({ event }: ExportRosterButtonProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button rank="secondary" leadingIcon="download-cloud" onClick={() => setOpen(true)}>
        {t('export_roster')}
      </Button>
      {open && <RosterExportModal open={open} setOpen={setOpen} event={event} />}
    </>
  )
}
